// Импорты
import { Reducer } from 'redux';
import { call, put, takeLatest } from 'redux-saga/effects';
import { TAppActions } from '../rootDuck';
import { ActionsUnion, createAction } from '../../utils/action-helper';
import { IPoint } from '../../interfaces/points';
import { getPickupPoints, getPickupCDEK, getCDEKCities } from '../../crud/pickupPoints.crud';

const CLEAR = 'pickupPoints/CLEAR';
const FETCH_REQUEST = 'pickupPoints/FETCH_REQUEST';
const FETCH_SUCCESS = 'pickupPoints/FETCH_SUCCESS';
const FETCH_FAIL = 'pickupPoints/FETCH_FAIL';

const CLEAR_CDEK = 'pickupPoints/CLEAR_CDEK';
const FETCH_REQUEST_CDEK = 'pickupPoints/FETCH_REQUEST_CDEK';
const FETCH_SUCCESS_CDEK = 'pickupPoints/FETCH_SUCCESS_CDEK';
const FETCH_FAIL_CDEK = 'pickupPoints/FETCH_FAIL_CDEK';

const CLEAR_CDEK_CITIES = 'pickupPoints/CLEAR_CDEK_CITIES';
const FETCH_REQUEST_CDEK_CITIES = 'pickupPoints/FETCH_REQUEST_CDEK_CITIES';
const FETCH_SUCCESS_CDEK_CITIES = 'pickupPoints/FETCH_SUCCESS_CDEK_CITIES';
const FETCH_FAIL_CDEK_CITIES = 'pickupPoints/FETCH_FAIL_CDEK_CITIES';

export interface IInitialState {
  pickupPoints: IPoint | null;
  loading: boolean;
  success: boolean;
  error: string | null;

  pickupPointsCdek: any | null;
  loadingCdek: boolean;
  successCdek: boolean;
  errorCdek: string | null;

  cdekCities: any | null;
  loadingCdekCities: boolean;
  successCdekCities: boolean;
  errorCdekCities: string | null;
}

const initialState: IInitialState = {
  pickupPoints: null,
  loading: false,
  success: false,
  error: null,

  pickupPointsCdek: null,
  loadingCdek: false,
  successCdek: false,
  errorCdek: null,

  cdekCities: null,
  loadingCdekCities: false,
  successCdekCities: false,
  errorCdekCities: null,
};

export const reducer: Reducer<IInitialState, TAppActions> = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case CLEAR: {
      return {
        ...state,
        pickupPoints: null,
        loading: false,
        success: false,
        error: null,
      };
    }

    case FETCH_REQUEST: {
      return {
        ...state,
        pickupPoints: null,
        loading: true,
        success: false,
        error: null,
      };
    }

    case FETCH_SUCCESS: {
      return {
        ...state,
        pickupPoints: action.payload,
        loading: false,
        success: true,
      };
    }

    case FETCH_FAIL: {
      return { ...state, loading: false, error: action.payload };
    }

    case CLEAR_CDEK: {
      return {
        ...state,
        pickupPointsCdek: null,
        loadingCdek: false,
        successCdek: false,
        errorCdek: null,
      };
    }

    case FETCH_REQUEST_CDEK: {
      return {
        ...state,
        pickupPointsCdek: null,
        loadingCdek: true,
        successCdek: false,
        errorCdek: null,
      };
    }

    case FETCH_SUCCESS_CDEK: {
      return {
        ...state,
        pickupPointsCdek: action.payload,
        loadingCdek: false,
        successCdek: true,
      };
    }

    case FETCH_FAIL_CDEK: {
      return { ...state, loadingCdek: false, errorCdek: action.payload };
    }

    case CLEAR_CDEK_CITIES: {
      return {
        ...state,
        cdekCities: null,
        loadingCdekCities: false,
        successCdekCities: false,
        errorCdekCities: null,
      };
    }

    case FETCH_REQUEST_CDEK_CITIES: {
      return {
        ...state,
        cdekCities: null,
        loadingCdekCities: true,
        successCdekCities: false,
        errorCdekCities: null,
      };
    }

    case FETCH_SUCCESS_CDEK_CITIES: {
      return {
        ...state,
        cdekCities: action.payload,
        loadingCdekCities: false,
        successCdekCities: true,
      };
    }

    case FETCH_FAIL_CDEK_CITIES: {
      return { ...state, loadingCdekCities: false, errorCdekCities: action.payload };
    }

    default:
      return state;
  }
};

export const actions = {
  clear: () => createAction(CLEAR),
  fetchRequest: () => createAction(FETCH_REQUEST),
  fetchSuccess: (payload: IPoint) => createAction(FETCH_SUCCESS, payload),
  fetchFail: (payload: string) => createAction(FETCH_FAIL, payload),

  clearCdek: () => createAction(CLEAR_CDEK),
  fetchRequestCdek: (city: string) => createAction(FETCH_REQUEST_CDEK, city),
  fetchSuccessCdek: (payload: any) => createAction(FETCH_SUCCESS_CDEK, payload),
  fetchFailCdek: (payload: string) => createAction(FETCH_FAIL_CDEK, payload),

  clearCdekCities: () => createAction(CLEAR_CDEK_CITIES),
  fetchRequestCdekCities: (name?: string) => createAction(FETCH_REQUEST_CDEK_CITIES, name),
  fetchSuccessCdekCities: (payload: any) => createAction(FETCH_SUCCESS_CDEK_CITIES, payload),
  fetchFailCdekCities: (payload: string) => createAction(FETCH_FAIL_CDEK_CITIES, payload),
};

export type TActions = ActionsUnion<typeof actions>;

function* fetchSaga({ payload }: any) {
  if (!payload) yield put(actions.clear());
  try {
    const { data }: { data: IPoint } = yield call(getPickupPoints);
    yield put(actions.fetchSuccess(data.data));
  } catch (e) {
    yield put(actions.fetchFail(e?.response?.data?.message || 'Network error'));
  }
}

function* fetchSagaCdek({ payload }: any) {
  if (!payload) yield put(actions.clearCdek());

  try {
    const { data }: { data: any } = yield call(getPickupCDEK, payload);
    yield put(actions.fetchSuccessCdek(data));
  } catch (e) {
    yield put(actions.fetchFailCdek(e?.response?.data?.message || 'Network error'));
  }
}

function* fetchSagaCdekCities({ payload }: any) {
  if (!payload) yield put(actions.clearCdekCities());
  try {
    const { data }: { data: any } = yield call(getCDEKCities, payload);
    yield put(actions.fetchSuccessCdekCities(data?.data));
  } catch (e) {
    yield put(actions.fetchFailCdekCities(e?.response?.data?.message || 'Network error'));
  }
}

export function* saga() {
  yield takeLatest<ReturnType<typeof actions.fetchRequest>>(FETCH_REQUEST, fetchSaga);
  yield takeLatest<ReturnType<typeof actions.fetchRequestCdek>>(
    FETCH_REQUEST_CDEK,
    fetchSagaCdek
  );
  yield takeLatest<ReturnType<typeof actions.fetchRequestCdekCities>>(
    FETCH_REQUEST_CDEK_CITIES,
    fetchSagaCdekCities
  );
}
